import { useContext, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link, Redirect } from 'react-router-dom';
import { GlobalContext } from '../../contexts/states/GlobalState';
import '../../styles/form_page.css';
import { GlobalErrorHandler } from '../Layouts/GlobalErrorHandler';
import { InnerLoading } from '../Layouts/InnerLoading';
import RegisterFormSvg from '../svgs/RegisterFormSvg';

export const RegisterPage = () => {
  const { error, setError, loading, registerAdmin, globalError, done } =
    useContext(GlobalContext);

  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [token, setToken] = useState('');
  const [iconName, setIconName] = useState('eye');
  const [formError, setFormError] = useState(false);
  const [passwordType, setPasswordType] = useState('password');

  const togglePasswordVisibility = () => {
    if (iconName === 'eye') {
      setIconName('eye-slash');
      setPasswordType('text');
    } else {
      setIconName('eye');
      setPasswordType('password');
    }
  };

  const verifyUserInput = (e) => {
    e.preventDefault();

    if (!password || !username || !token) {
      return setFormError('All fields are required');
    }

    if (password.length <= 8)
      return setFormError('Password should be longer than 8');

    registerAdmin(username, password, token);
  };

  useEffect(() => {
    let t;
    if (formError) {
      t = setTimeout(() => {
        setFormError(false);
      }, 4000);
    }

    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [formError]);

  useEffect(() => {
    let t;
    if (error) {
      t = setTimeout(() => {
        setError(false);
      }, 4000);
    }

    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, [error]);

  return (
    <div className='form-page-container'>
      {done && <Redirect push to={done} />}
      <Helmet>
        <title>Register an Account | LionTaxi Admin</title>
      </Helmet>
      <div className='form-page-link'>
        <Link to='/admin'>Login</Link>
      </div>
      <div className='form-page-header'>
        <h3>Register</h3>
      </div>
      <div className='form-card-con register'>
        <div className='form-svg'>
          <RegisterFormSvg />
        </div>
        <div className='form-page-form'>
          <form onSubmit={verifyUserInput}>
            <label htmlFor='username'>Username</label>
            <input
              type='text'
              id='username'
              name='username'
              placeholder='e.g john_doe'
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required={true}
            />
            <div className='password-con'>
              <label htmlFor='password'>Password</label>
              <input
                type={passwordType}
                name='password'
                id='password'
                placeholder='Enter password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required={true}
              />
              <div className='password-icon'>
                <i
                  className={`fas fa-${iconName}`}
                  onClick={togglePasswordVisibility}
                ></i>
              </div>
            </div>
            <label htmlFor='token'>Auth Token</label>
            <input
              type='text'
              id='token'
              name='token'
              placeholder='Enter auth token'
              value={token}
              onChange={(e) => setToken(e.target.value)}
              required={true}
              autoComplete='off'
            />
            <button
              className='form-submit'
              onClick={verifyUserInput}
              disabled={loading}
            >
              {loading ? <InnerLoading color='#f5feffd4' /> : 'Register'}
            </button>
            {formError && (
              <div className='form-error'>
                <p>{formError}</p>
              </div>
            )}
            {error && (
              <div className='form-error'>
                <p>{error}</p>
              </div>
            )}
          </form>
        </div>
      </div>
      <div className='connection-error-handler'>
        <div className={`modal-con ${globalError && 'active'}`}>
          {globalError && (
            <GlobalErrorHandler error={globalError} context={GlobalContext} />
          )}
        </div>
      </div>
    </div>
  );
};
